export const GET_EVENTS = "GET_EVENTS";
export const GET_EVENTS_COMPLETE = "GET_EVENTS_COMPLETE";
export const GET_COMPLETE_UPCOMING_EVENTS = "GET_COMPLETE_UPCOMING_EVENTS";
export const GET_COMPLETE_UPCOMING_EVENTS_COMPLETE =
	"GET_COMPLETE_UPCOMING_EVENTS_COMPLETE";
export const CLEAR_EVENTS_COMPLETE = "CLEAR_EVENTS_COMPLETE";
export const GET_EVENTS_SUMMARY = "GET_EVENTS_SUMMARY";
export const GET_EVENTS_SUMMARY_COMPLETE = "GET_EVENTS_SUMMARY_COMPLETE";
export const SET_SELECTED_EVENT = "SET_SELECTED_EVENT";
export const SET_SELECTED_EVENT_COMPLETE = "SET_SELECTED_EVENT_COMPLETE";
export const GET_EVENT_DEFAULT_GAME_CONFIGURATION =
	"GET_EVENT_DEFAULT_GAME_CONFIGURATION";
export const GET_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE =
	"GET_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE";
export const SAVE_EVENT_DEFAULT_GAME_CONFIGURATION =
	"SAVE_EVENT_DEFAULT_GAME_CONFIGURATION";
export const SAVE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE =
	"SAVE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE";
export const INIT_EVENT_DATA = "INIT_EVENT_DATA";
export const INIT_EVENT_DATA_COMPLETE = "INIT_EVENT_DATA_COMPLETE";
export const RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION =
	"RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION";
export const RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE =
	"RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE";
export const SAVE_EVENT = "SAVE_EVENT";
export const SAVE_EVENT_COMPLETE = "SAVE_EVENT_COMPLETE";
export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const SET_REMOTE_EVENT_CHANGED = "SET_REMOTE_EVENT_CHANGED";
export const OVER_WRITE_EVENT_DATA = "OVER_WRITE_EVENT_DATA";
export const OVER_WRITE_EVENT_DATA_COMPLETE = "OVER_WRITE_EVENT_DATA_COMPLETE";
export const RESET_EVENT_DATA = "RESET_EVENT_DATA";
export const RESET_EVENT_DATA_COMPLETE = "RESET_EVENT_DATA_COMPLETE";
export const RESET_CURRENT_EVENT = "RESET_CURRENT_EVENT";
export const GET_UPCOMING_EVENTS = "GET_UPCOMING_EVENTS";
export const GET_UPCOMING_EVENTS_COMPLETE = "GET_UPCOMING_EVENTS_COMPLETE";
export const GET_IN_PROGRESS_EVENTS = "GET_IN_PROGRESS_EVENTS";
export const GET_IN_PROGRESS_EVENTS_COMPLETE =
	"GET_IN_PROGRESS_EVENTS_COMPLETE";
export const GET_COMPLETED_EVENTS = "GET_COMPLETED_EVENTS";
export const GET_COMPLETED_EVENTS_COMPLETE = "GET_COMPLETED_EVENTS_COMPLETE";
export const UPDATE_CURRENT_EVENT_COMPLETE = "UPDATE_CURRENT_EVENT_COMPLETE";
export const SET_RULE_SET_ID_COMPLETE = "SET_RULE_SET_ID_COMPLETE";
export const SELECT_EVENT_STREAM = "SELECT_EVENT_STREAM";
export const SELECT_EVENT_STREAM_COMPLETE = "SELECT_EVENT_STREAM_COMPLETE";
